import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const LogoText = styled(Typography)(({ theme }) => ({
  fontWeight: '500',
  fontSize: '1.5rem',
  marginLeft: theme.spacing(1),
  marginBottom: '-6px',
  color: theme.vars?.palette.text.primary ?? theme.palette.text.primary,
}));

type LogoProps = {
  isDefaultPerplImage?: boolean;
  isPnlCard?: boolean;
};

export const Logo = ({ isDefaultPerplImage = false, isPnlCard = false }: LogoProps) => {
  let color: string;
  if (!isPnlCard) {
    color = '#6F5CFF';
  } else if (isDefaultPerplImage) {
    color = 'var(--mui-palette-primary-main)';
  } else {
    color = 'var(--mui-palette-text-primary)';
  }
  return (
    <Box display="flex" alignItems="center">
      <svg height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <rect x="0" y="0" width="3" height="16" fill={color} />
        <rect x="6" y="8" width="3" height="8" fill={color} />
        <rect x="9" y="0" width="3" height="8" fill={color} />
      </svg>
      <LogoText>
        <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 52 20" fill="none">
          <mask id="mask0_3249_41066" maskUnits="userSpaceOnUse" x="0" y="0" width="52" height="20">
            <path d="M51.1962 0.0290527H0.139648V20H51.1962V0.0290527Z" fill="white" />
          </mask>
          <g mask="url(#mask0_3249_41066)">
            <path
              d="M13.2317 10.0504C13.2317 6.43727 15.5768 3.92432 19.082 3.92432C22.8529 3.92432 25.0533 6.77187 24.835 10.8408H15.9399C15.9885 12.7795 17.2932 14.0477 19.107 14.0477C20.7998 14.0477 21.6455 13.2573 22.0558 12.2053L24.643 12.5399C24.0866 14.2873 22.3702 16.1778 19.1557 16.1778C15.2152 16.1778 13.2331 13.4735 13.2331 10.0518L13.2317 10.0504ZM15.9399 8.87862H22.1045C22.0322 7.08444 20.7261 5.95947 19.107 5.95947C17.488 5.95947 16.0372 6.84485 15.9399 8.87862Z"
              fill="currentColor"
            />
            <path
              d="M33.3559 6.79678C32.9205 6.74859 32.5338 6.72518 32.1235 6.72518C30.4558 6.72518 29.489 7.46736 29.489 9.86052V15.8916H26.8059V4.16404H29.4404V6.1028C30.0927 4.83462 31.2542 4.16403 32.7035 4.14062C32.9205 4.14062 33.1625 4.16404 33.3559 4.18883V6.79678Z"
              fill="currentColor"
            />
            <path
              d="M37.6902 20.0292H35.0071V4.16392H37.5942L37.6179 5.60008C38.3912 4.49989 39.5513 3.92432 41.1467 3.92432C44.0955 3.92432 46.2237 6.22109 46.2237 10.0738C46.2237 13.9265 43.9759 16.1765 40.9534 16.1765C39.4066 16.1765 38.3426 15.5307 37.6902 14.6935V20.0292ZM37.5692 10.0738C37.5692 12.6583 38.8016 14.0463 40.5903 14.0463C42.3791 14.0463 43.4668 12.4669 43.4668 10.0504C43.4668 7.63385 42.4751 6.05448 40.5903 6.05448C38.8252 6.05448 37.5692 7.44245 37.5692 10.0752V10.0738Z"
              fill="currentColor"
            />
            <path d="M51.0434 15.8901H48.0613V0H51.0434V15.8901Z" fill="currentColor" />
            <path d="M0.619995 0H3.5822V15.8901H0.619995V0Z" fill="currentColor" />
            <path
              d="M5.38277 0H5.31317V2.36836H5.38277C7.38847 2.36836 9.34697 2.58317 9.34697 5.21591C9.34697 7.53747 7.67916 7.94367 5.52737 7.94367H5.31177V10.2653H5.43007C9.27327 10.2653 12.2958 9.26004 12.2958 5.19251C12.2972 0.693987 8.96027 0 5.38277 0Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </LogoText>
    </Box>
  );
};
